import { render, staticRenderFns } from "./points.vue?vue&type=template&id=6f93b71c&scoped=true&"
import script from "./points.vue?vue&type=script&lang=ts&"
export * from "./points.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f93b71c",
  null
  
)

export default component.exports